import './Statistics.css'
import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import {
  collection,
  query,
  onSnapshot,
} from 'firebase/firestore';
import { AuthContext } from '../../services/AuthContext';

ChartJS.register(ArcElement, Tooltip, Legend);

const ENTRIES_COLLECTION = 'pdfEntries';

function Estadisticas() {
  const { db } = useContext(AuthContext);
  const [allEntries, setAllEntries] = useState([]);

  useEffect(() => {
    if (!db) return;
    const q = query(collection(db, ENTRIES_COLLECTION));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setAllEntries(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return unsubscribe;
  }, [db]);

  const parseDate = (vencimiento) => {
    if (!vencimiento || typeof vencimiento !== 'string') return null;
    const str = vencimiento.trim();
    const parts = str.split(/[/\.-]/);
    if (parts.length !== 3) return null;

    let day, month, year;
    if (parts[0].length <= 2 && parts[1].length <= 2 && parts[2].length === 4) {
      day = parseInt(parts[0], 10);
      month = parseInt(parts[1], 10) - 1;
      year = parseInt(parts[2], 10);
    } else if (parts[0].length === 4 && parts[2].length <= 2) {
      year = parseInt(parts[0], 10);
      month = parseInt(parts[1], 10) - 1;
      day = parseInt(parts[2], 10);
    } else return null;

    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) return null;
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const today = new Date(); today.setHours(0, 0, 0, 0);
  const treintaDias = new Date(today); treintaDias.setDate(today.getDate() + 30);

  const stats = useMemo(() => {
    const pendientes = allEntries.filter(e =>
      ['En trámite C/Pendiente', 'En trámite S/Pendiente'].includes(e.estadoGestion) ||
      ['En trámite C/Pendiente', 'En trámite S/Pendiente'].includes(e.auditoria2025)
    ).length;

    const informativos = allEntries.filter(e =>
      e.estadoGestion === 'Informativo' && e.auditoria2025 === 'Informativo'
    ).length;

    const cumplidas = allEntries.filter(e =>
      e.estadoGestion === 'Cumple' && e.auditoria2025 === 'Cumple'
    ).length;

    const seDebenAdecuarOProximos = allEntries.filter(e => {
      const fecha = parseDate(e.vencimiento);
      const esProximo = fecha && fecha >= today && fecha <= treintaDias;
      const esAdecuar = e.estadoGestion === 'Se debe adecuar' || e.auditoria2025 === 'Se debe adecuar';
      return esProximo || esAdecuar;
    }).length;

    const noCumplidasOVencidas = allEntries.filter(e => {
      const fecha = parseDate(e.vencimiento);
      const vencido = fecha && fecha < today;
      return e.estadoGestion === 'No cumple' || e.auditoria2025 === 'No cumple' || vencido;
    }).length;

    const total = allEntries.length;

    return {
      pendientes,
      informativos,
      cumplidas,
      seDebenAdecuarOProximos,
      noCumplidasOVencidas,
      total,
    };
  }, [allEntries]);

  const data = {
    labels: [
      'Pendientes',
      'Informativo',
      'Cumplidas',
      'Se deben adecuar o próximas a vencer',
      'No cumplidas o vencidas',
    ],
    datasets: [{
      data: [
        stats.pendientes,
        stats.informativos,
        stats.cumplidas,
        stats.seDebenAdecuarOProximos,
        stats.noCumplidasOVencidas,
      ],
      backgroundColor: [
        '#95a5a6',
        '#3498db',
        '#2ecc71',
        '#f3e412', 
        '#e74c3c', 
      ],
      borderColor: '#1f1f1f',
      borderWidth: 4,
    }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '65%',
    plugins: {
        legend: {
            position: 'right',
            onClick: (e, legendItem, legend) => {
            const index = legendItem.index;
            const chart = legend.chart;

            chart.toggleDataVisibility(index);
            chart.update();
            },
            labels: {
            font: { size: 14 },
            padding: 20,
            usePointStyle: true,
            generateLabels: (chart) => {
                const data = chart.data;

                return data.labels.map((label, i) => {
                const value = data.datasets[0].data[i];
                const backgroundColor = data.datasets[0].backgroundColor[i];
                const hidden = !chart.getDataVisibility(i);

                return {
                    text: `${label}: ${value}`,
                    fillStyle: backgroundColor,
                    strokeStyle: backgroundColor,
                    hidden: hidden, 
                    color: "#f5f5f5",
                    fontColor: "#f5f5f5",
                    index: i
                };
                });
            }
            }
        },

        tooltip: {
            enabled: false
        }
    }
  };

  return (
    <div className="estadisticas">
    <h2>Estadísticas</h2>
    <p className="subtitulo">Estado actual</p>

    <div className="total-box">
        <span className="total-numero">{stats.total}</span>
        <span className="total-texto">normas</span>
    </div>

    <div className="grafico-container">
        <Doughnut data={data} options={options} />
    </div>

    {stats.total === 0 && <p>No hay datos aún.</p>}
    </div>
  );
}

export default Estadisticas;
